// Shared pure contract/editor helpers for environment-scoped, composable client filters.
const TYPES = [
    { id: 'IP_ADDRESS', label: 'IP Address' },
    { id: 'HTTP_HEADER', label: 'Standard HTTP Header' },
    { id: 'CUSTOM_HTTP_HEADER', label: 'Custom HTTP Header' },
    { id: 'JSON_FIELD', label: 'JSON Payload Field' }
];
function values(mapping) {
    return Array.isArray(mapping.values) ? mapping.values.slice() : mapping.value == null || mapping.value === '' ? [] : [mapping.value];
}
function editor(mappings) {
    var m = mappings || {};
    var filters = Array.isArray(m.filters) ? m.filters : [
        ['IP_ADDRESS', m.ipAddressMapping], ['HTTP_HEADER', m.httpHeaderMapping],
        ['CUSTOM_HTTP_HEADER', m.customHttpHeaderMapping], ['JSON_FIELD', m.jsonFieldMapping]
    ].filter(function (pair) { return pair[1] && pair[1].enabled; }).map(function (pair) {
        var item = pair[1], standard = pair[0] === 'HTTP_HEADER';
        return { type: pair[0], headerId: standard && item.header ? item.header.id : null,
            header: standard ? (item.header && item.header.name) : item.header || null,
            fieldNotation: item.fieldNotation || null, values: values(item) };
    });
    return { filters: filters.map(function (f) {
        return { type: f.type, headerId: f.headerId || null, header: f.header || null,
            fieldNotation: f.fieldNotation || null, values: values(f) };
    }) };
}
function serialize(state) {
    return { filters: state.filters.map(function (f) {
        return { type: f.type, headerId: f.type === 'HTTP_HEADER' ? f.headerId : null,
            header: f.type === 'HTTP_HEADER' || f.type === 'CUSTOM_HTTP_HEADER' ? f.header : null,
            fieldNotation: f.type === 'JSON_FIELD' ? f.fieldNotation : null, values: f.values.slice() };
    }) };
}
function normalize(value, type) {
    value = String(value).trim();
    return type === 'IP_ADDRESS' && value && !/\/\d+$/.test(value) ? value + '/32' : value;
}
function error(filter) {
    if (!TYPES.some(function (t) { return t.id === filter.type; })) return 'Select a filter type.';
    if (filter.type === 'HTTP_HEADER' && (!filter.headerId || !filter.header)) return 'Select a standard HTTP header.';
    if (filter.type === 'CUSTOM_HTTP_HEADER' && (!filter.header || !filter.header.trim())) return 'Enter a custom HTTP header name.';
    if (filter.type === 'JSON_FIELD' && (!filter.fieldNotation || !/^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*$/.test(filter.fieldNotation))) return 'Enter a JSON field path, such as client.id.';
    if (!filter.values.length) return 'Add at least one allowed value.';
    var octet = '(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    var cidr = new RegExp('^' + [octet,octet,octet,octet].join('\\.') + '/(3[0-2]|[12]?[0-9])$');
    for (var value of filter.values) {
        if (typeof value !== 'string' || !value.trim()) return 'Values cannot be empty.';
        if (filter.type === 'IP_ADDRESS') {
            if (!cidr.test(value.trim())) return 'Enter valid IPv4/CIDR values, such as 10.0.0.1/32.';
        } else {
            try { new RegExp(value); } catch (_) { return 'Each value must be a valid regular expression.'; }
        }
    }
    return '';
}
function valid(state) {
    var used = new Set();
    return state.filters.every(function (f) {
        if (used.has(f.type) || error(f)) return false;
        used.add(f.type); return true;
    });
}
function bind(vm, client) {
    vm.clientFilterTypes = TYPES;
    vm.mappingStates = {};
    vm.environments.forEach(function (env) {
        var saved = client && (client.environments || []).find(function (e) { return e.id === env.id; });
        vm.mappingStates[env.id] = editor(saved && (saved.clientMappings || client.clientMappings));
    });
    var original = JSON.stringify(vm.environments.map(function (e) { return serialize(vm.mappingStates[e.id]); }));
    vm.mappingTabIndex = 0;
    vm.mapping = vm.environments.length ? vm.mappingStates[vm.environments[0].id] : editor();
    vm.selectMappingEnvironment = function (id) { vm.mapping = vm.mappingStates[id]; };
    vm.availableClientFilterTypes = function (filter) {
        return TYPES.filter(function (type) { return !vm.mapping.filters.some(function (other) { return other !== filter && other.type === type.id; }); });
    };
    vm.addClientFilter = function () { if (vm.mapping.filters.length >= TYPES.length) return; vm.mapping.filters.push({ type: null, headerId: null, header: null, fieldNotation: null, values: [] }); };
    vm.removeClientFilter = function (index) { vm.mapping.filters.splice(index, 1); };
    vm.clientFilterTypeChanged = function (f) { f.headerId = null; f.header = null; f.fieldNotation = null; f.values = []; };
    vm.clientHeaderChanged = function (f) {
        var header = (vm.predefinedHeaders || []).find(function (h) { return h.refId === f.headerId; });
        f.header = header ? header.refObjectLabel : null;
    };
    vm.normalizeClientFilterValue = normalize;
    vm.clientFilterError = error;
    vm.environmentMappingPayload = function (id) { return serialize(vm.mappingStates[id]); };
    vm.environmentMappingsDirty = function () {
        return original !== JSON.stringify(vm.environments.map(function (e) { return serialize(vm.mappingStates[e.id]); }));
    };
    vm.invalidMappingEnvironments = function () {
        return vm.environments.filter(function (e) { return vm.selectedEnvIds.indexOf(e.id) !== -1 && !valid(vm.mappingStates[e.id]); });
    };
}
module.exports = { editor: editor, serialize: serialize, valid: valid, bind: bind, error: error, normalize: normalize };
